import {Injectable} from '@angular/core';
import {PagingApiService} from '@abstract/paging-api.service';
import {EquipmentCardInterfaces} from '@namespaces/equipment.namespace';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {ApiPaginationResponse} from '@abstract/api.service';

interface EquipmentListPagesResponse extends ApiPaginationResponse<EquipmentCardInterfaces.Card.ItemView> {
    equipment_ids: number[];
}

@Injectable()
export class EquipmentListPagesService extends PagingApiService<EquipmentCardInterfaces.Card.ItemView> {
    public objectId: number;

    get pagingUrl(): string {
        return `working-object/${this.objectId}/equipment`;
    }

    defaultItemsPerPage = 10;

    equipmentIds$ = new BehaviorSubject<number[]>([]);

    protected handlePagingDataReceive(data: EquipmentListPagesResponse) {
        super.handlePagingDataReceive(data);

        if (!data || !data.equipment_ids) {
            this.equipmentIds$.next([]);
            return;
        }

        this.equipmentIds$.next(data.equipment_ids);
    }
}
